export default __webpack_public_path__ + "static/media/filling.4a51de15.svg";